import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import pickBy from './pickBy';
export default function getModifiedProps(prevProps, currProps) {
  var childrenIsText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var children = currProps.children,
      rest = _objectWithoutProperties(currProps, ["children"]);

  var modifiedProps = pickBy(rest, function (propName, value) {
    if (!prevProps) return true;
    return Object.is(value, prevProps[propName]) === false;
  });

  if (childrenIsText && (!prevProps || Object.is(prevProps.children, children) === false)) {
    modifiedProps.text = children;
  }

  if (Object.keys(modifiedProps).length > 0) {
    return modifiedProps;
  }

  return false;
}